import * as Yup from "yup";
import { GrandezaEnergia } from "../boletagem";

export class BoletagemPgtoDiferenciadoSchema {
  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }
}

const recordShape = {
  id: Yup
    .number(),
  contraparte: Yup.object()
    .required("Contraparte é obrigatório")
    .shape({
      id: Yup
        .number()
        .typeError("Valor inválido")
        .required("Contraparte é obrigatório"),
    }),
  cnpj: Yup
    .string()
    .typeError("Valor inválido")
    .required("Campo obrigatório"),
  ccee: Yup.object()
    .required("Agente é obrigatório")
    .shape({
      id: Yup
        .number()
        .typeError("Valor inválido")
        .required("Agente é obrigatório"),
    }),
  grandeza: Yup
    .mixed<GrandezaEnergia>().oneOf(Object.values(GrandezaEnergia), `Grandeza deve ser "${Object.values(GrandezaEnergia).join('" ou "')}"`)
    .required("Grandeza é obrigatório"),
  volumeEnergiaMedio: Yup
    .number()
    .typeError("Valor inválido")
    .required("Campo obrigatório"),
  volumeEnergiaHora: Yup
    .number()
    .typeError("Valor inválido")
    .required("Campo obrigatório"),
  valor: Yup
    .number()
    .typeError("Valor inválido")
    .required("Campo obrigatório"),
};
